/* Bulk sale 2026-10-09 (v2), Rubber Feet Warehouse.
   Loaded (deferred) only by the bulk-sale snippets, and only while Theme settings -> "Bulk sale (2026-10-09)" is on.
   - [data-bk-calc]   "You save" calculator: single-piece price, the Bulk Tier Pricing app's tiers (the app's own [data-qb-data]
                      on product pages, else the theme's copy from snippets/bulk-tiers) and every real "Case of N" variant.
   - [data-bkq]       Quick-order form on the bulk page: one POST /cart/add.js with every line, then the cart.
   - [data-bk-sticky] Case-pricing strip in the sticky add-to-cart bar on phones: scrolls to the case box (case variants exist)
                      or opens the bulk quote form (no case variants yet).
   - [data-bk-fs]     Free-shipping nudge in the cart: smallest case of a part in the cart that reaches the free-shipping minimum.
   Numbers come only from variant prices and the app tiers. GA4 events go through window.rfwTrack (snippets/rfw-track). */
(function () {
  'use strict';
  if (window.__bkSale) return;
  window.__bkSale = 1;

  var fmt;
  try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); }
  catch (e) { fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }
  function money(c) { return fmt.format(Math.round(c) / 100); }
  /* price per piece, rounded to a tenth of a cent: $0.10, $0.369 */
  function pp(c, n) {
    var m = Math.round((c * 10) / (n || 1));
    return '$' + (m % 10 === 0 ? (m / 1000).toFixed(2) : (m / 1000).toFixed(3));
  }
  function num(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function track(name, params) { try { if (typeof window.rfwTrack === 'function') window.rfwTrack(name, params || {}); } catch (e) {} }
  function json(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  function tiers(fallback) {
    var t = null, el = document.querySelector('[data-qb-data]');
    if (el) { var d = json(el); if (d && d.tiers && d.tiers.length) t = d.tiers; }
    if (!t) t = fallback || [];
    return t.filter(function (x) { return x.type === 'percentage' && x.value >= 1; })
      .sort(function (a, b) { return a.minQty - b.minQty; });
  }
  function tierFor(q, t) { var r = null; for (var i = 0; i < t.length; i++) if (q >= t[i].minQty) r = t[i]; return r; }
  function unitFor(price, q, t) { var x = tierFor(q, t); return x ? price * (1 - x.value / 100) : price; }
  function lineFor(price, q, t) { return Math.round(unitFor(price, q, t) * q); }
  function cases(p) { return (p.cases || []).filter(function (c) { return c.pcs > 0; }).sort(function (a, b) { return a.pcs - b.pcs; }); }

  /* Opens the bulk quote form near the element (product page box) or jumps to the page's #quote. */
  function openQuote(sku) {
    var box = document.getElementById('bulk-case');
    var form = box && box.querySelector('form.bq-form, form[id^="bulk-quote"]');
    if (form) {
      var d = form.closest('details');
      if (d) d.open = true;
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var q = form.querySelector('input[name="contact[Quantity]"]');
      if (q) setTimeout(function () { q.focus({ preventScroll: true }); }, 400);
      return true;
    }
    var page = document.getElementById('bulk-quote-page');
    if (page) {
      var s = page.querySelector('input[name="contact[SKU]"]');
      if (s && sku) s.value = sku;
      var a = document.getElementById('quote');
      (a || page).scrollIntoView({ behavior: 'smooth', block: 'start' });
      var q2 = page.querySelector('input[name="contact[Quantity]"]');
      if (q2) setTimeout(function () { q2.focus({ preventScroll: true }); }, 400);
      return true;
    }
    return false;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bk-quote-open]');
    if (!a) return;
    if (openQuote(a.getAttribute('data-bk-quote-open'))) e.preventDefault();
  });

  /* ---------- "You save" calculator ---------- */
  function Calc(root) {
    var cfg = json(root.querySelector('script[data-bk-calc-data]'));
    if (!cfg || !cfg.products || !cfg.products.length) return;
    var T0 = tiers(cfg.tiers);
    var uid = root.id || ('bkc' + Math.random().toString(36).slice(2, 7));
    var ui = root.querySelector('[data-bk-calc-ui]');
    var products = cfg.products.filter(function (p) { return p.single && p.single.price > 0; });
    if (!products.length) return;
    var html = '<div class="bk-calc__ctl">';
    if (products.length > 1) {
      html += '<div class="bk-calc__f"><label for="' + uid + '-p">Part</label><select id="' + uid + '-p" data-p>';
      products.forEach(function (p, i) { html += '<option value="' + i + '">' + esc(cfg.labels && cfg.labels[i] ? cfg.labels[i] : p.title) + '</option>'; });
      html += '</select></div>';
    }
    html += '<div class="bk-calc__f"><label for="' + uid + '-q">Pieces you need</label><input id="' + uid + '-q" type="number" min="1" step="1" inputmode="numeric" data-q></div></div>';
    html += '<div class="bk-calc__out" data-out aria-live="polite"></div>';
    ui.innerHTML = html;
    var sel = ui.querySelector('[data-p]'), qi = ui.querySelector('[data-q]'), out = ui.querySelector('[data-out]');
    function cur() { return products[sel ? parseInt(sel.value, 10) || 0 : 0]; }
    function defQty(p) { var c = cases(p); return c.length ? c[0].pcs : (cfg.defaultQty || 1000); }
    qi.value = defQty(cur());

    function row(name, per, extra, cls) {
      return '<li class="bk-calc__r' + (cls ? ' ' + cls : '') + '"><span class="bk-calc__o">' + name + '</span><span class="bk-calc__v">' + per + '</span>' + (extra ? '<span class="bk-calc__x">' + extra + '</span>' : '') + '</li>';
    }
    function render() {
      var p = cur(), s = p.single.price, q = parseInt(qi.value, 10);
      var T = p.noTiers ? [] : T0; /* 2026-10-16: restock70 parts are on RESTOCK70, the tiers don't apply */
      if (!(q > 0)) q = 0;
      var h = '<p class="bk-calc__h">Price per piece</p><ul class="bk-calc__l" role="list">';
      h += row('Single pieces' + (T.length ? ' (1&ndash;' + num(T[0].minQty - 1) + ')' : ''), pp(s, 1) + ' each', '', 'is-base');
      T.forEach(function (t) {
        var u = s * (1 - t.value / 100);
        h += row(num(t.minQty) + '+ pcs, ' + Math.round(t.value) + '% off', pp(u, 1) + ' each', 'You save ' + pp(s - u, 1) + ' per piece');
      });
      var cs = cases(p);
      cs.forEach(function (c) {
        var save = s * c.pcs - c.price;
        h += row(esc(c.label) + ' (' + money(c.price) + ')', pp(c.price, c.pcs) + ' each',
          save > 0 ? 'You save ' + money(save) + ' vs ' + num(c.pcs) + ' single pieces (' + Math.floor(save / (s * c.pcs) * 100) + '%)' : '', 'is-case');
      });
      h += '</ul>';
      if (q > 0) {
        var base = s * q, opts = [];
        var tq = tierFor(q, T), tl = lineFor(s, q, T);
        opts.push({ n: 'Single pieces at ' + pp(s, 1) + ' each', pay: base, pcs: q, save: 0 });
        if (tq) opts.push({ n: num(q) + ' pcs with the ' + Math.round(tq.value) + '% quantity discount', pay: tl, pcs: q, save: base - tl });
        cs.forEach(function (c) {
          if (!c.available) return;
          var k = Math.ceil(q / c.pcs), pcs = k * c.pcs, pay = k * c.price;
          opts.push({ n: k + ' &times; ' + esc(c.label) + (pcs > q ? ' (' + num(pcs) + ' pcs)' : ''), pay: pay, pcs: pcs, save: s * pcs - pay, cse: 1 });
        });
        var best = null;
        opts.forEach(function (o) { if (o.save > 0 && (!best || o.pay < best.pay)) best = o; });
        h += '<p class="bk-calc__h">For ' + num(q) + ' pcs</p><ul class="bk-calc__l" role="list">';
        opts.forEach(function (o) {
          var x = o.save > 0 ? 'You save ' + money(o.save) + ' vs single pieces' : 'List price';
          h += row(o.n + (o === best ? ' <span class="bk-calc__best">Lowest cost</span>' : ''), money(o.pay) + ' &middot; ' + pp(o.pay, o.pcs) + '/pc', x, o === best ? 'is-best' : '');
        });
        h += '</ul>';
        if (!cs.length) {
          h += '<p class="bk-calc__n">Case packs of this part are priced on request. <a href="' + (cfg.quoteHref || '#quote') + '" data-bk-quote-open="' + esc(p.single.sku || '') + '">Get case price</a></p>';
        }
      }
      h += '<p class="bk-calc__n">' + (p.noTiers ? 'This part is on a restock sale: the sale price is applied in the cart (quantity tiers don\'t apply); the cart shows the final price.' : 'Quantity discounts are applied in the cart; the cart shows the final price.') + '</p>';
      out.innerHTML = h;
      var sum = root.closest('details') && root.closest('details').querySelector('[data-bk-calc-sum]');
      if (sum) {
        var mx = 0;
        T.forEach(function (t) { if (t.value > mx) mx = t.value; });
        cs.forEach(function (c) { var v = (1 - c.price / (s * c.pcs)) * 100; if (v > mx) mx = v; });
        if (mx >= 1) sum.textContent = 'You save calculator: up to ' + Math.floor(mx) + '% off the single-piece price';
      }
    }
    qi.addEventListener('input', render);
    if (sel) sel.addEventListener('change', function () { qi.value = defQty(cur()); render(); });
    render();
  }

  /* ---------- Quick order (bulk page) ---------- */
  function Quick(root) {
    var cfg = json(root.querySelector('script[data-bkq-data]')) || {};
    var T0 = tiers(cfg.tiers);
    var ins = [].slice.call(root.querySelectorAll('[data-bkq-in]'));
    var totEl = root.querySelector('[data-bkq-total]'), btn = root.querySelector('[data-bkq-add]'), msg = root.querySelector('[data-bkq-msg]');
    function val(i) { var v = parseInt(i.value, 10); return v > 0 ? v : 0; }
    function render() {
      var total = 0, pcsAll = 0, lines = 0, warn = false;
      [].forEach.call(root.querySelectorAll('[data-bkq-row]'), function (r) {
        var sum = 0, pcs = 0, notes = [], T = r.hasAttribute('data-bkq-notiers') ? [] : T0;
        [].forEach.call(r.querySelectorAll('[data-bkq-in]'), function (i) {
          var q = val(i), price = parseInt(i.dataset.price, 10);
          if (!q) return;
          if (i.dataset.kind === 'single') {
            var l = lineFor(price, q, T), m = q;
            /* smallest quantity >= q whose discounted line reaches $20.00 (a tier step can drop a line back under it) */
            for (var g = 0; g < 5000 && lineFor(price, m, T) < 2000; g++) m++;
            sum += l; pcs += q;
            var t = tierFor(q, T);
            if (t) notes.push(Math.round(t.value) + '% quantity discount included');
            if (l < 2000) { notes.push('<span class="bkq-warn">Under the $20.00 checkout minimum per item: use ' + num(m) + ' pcs or more</span>'); warn = true; }
          } else {
            sum += q * price; pcs += q * parseInt(i.dataset.pcs, 10);
          }
          lines++;
        });
        var out = r.querySelector('[data-bkq-line]');
        if (out) out.innerHTML = pcs ? num(pcs) + ' pcs &middot; ' + money(sum) + (notes.length ? '<br>' + notes.join('<br>') : '') : '';
        total += sum; pcsAll += pcs;
      });
      if (totEl) totEl.innerHTML = lines ? '<strong>' + num(pcsAll) + ' pcs &middot; ' + money(total) + '</strong> estimated' + (warn ? ' &middot; fix the highlighted line before checkout' : '') : 'Enter a quantity for any part above.';
      if (btn) btn.disabled = !lines;
      return { total: total, lines: lines };
    }
    ins.forEach(function (i) { i.addEventListener('input', function () { if (msg) msg.textContent = ''; render(); }); });
    root.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [], ga = [], s = render();
      ins.forEach(function (i) {
        var q = val(i);
        if (!q) return;
        items.push({ id: parseInt(i.dataset.id, 10), quantity: q });
        ga.push({ item_id: i.dataset.sku || i.dataset.id, item_variant: i.dataset.label || '', quantity: q, price: parseInt(i.dataset.price, 10) / 100 });
      });
      if (!items.length) return;
      btn.disabled = true;
      if (msg) msg.textContent = 'Adding ' + items.length + (items.length === 1 ? ' line' : ' lines') + ' to your cart…';
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, d: d }; });
      }).then(function (res) {
        if (!res.ok) {
          btn.disabled = false;
          if (msg) msg.textContent = (res.d && (res.d.description || res.d.message)) || 'Could not add these items. Please check the quantities.';
          return;
        }
        track('quick_order_add', { items: ga, value: Math.round(s.total) / 100, currency: 'USD', line_count: items.length });
        if (msg) msg.textContent = 'Added. Opening your cart…';
        setTimeout(function () { location.href = cfg.cartUrl || '/cart'; }, 350);
      }).catch(function () {
        btn.disabled = false;
        if (msg) msg.textContent = 'Network error. Please try again.';
      });
    });
    render();
  }

  /* ---------- Sticky case strip (product pages, phones) ---------- */
  function Sticky(a) {
    var box = document.getElementById('bulk-case');
    a.addEventListener('click', function (e) {
      if (a.dataset.mode === 'quote') { if (openQuote(a.dataset.sku)) e.preventDefault(); return; }
      if (box) { e.preventDefault(); box.scrollIntoView({ behavior: 'smooth', block: 'start' }); var f = box.querySelector('button, a'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 450); }
    });
    if (a.dataset.standalone && box && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting) seen = true;
          var past = !x.isIntersecting && x.boundingClientRect.top < 0;
          a.classList.toggle('is-on', past || (seen && !x.isIntersecting && x.boundingClientRect.top > window.innerHeight));
        });
      }).observe(box);
    }
  }

  /* ---------- Free-shipping nudge (cart) ---------- */
  function FreeShip(root) {
    var cfg = json(root.querySelector('script[data-bk-fs-data]'));
    if (!cfg) return;
    var out = root.querySelector('[data-bk-fs-out]');
    var byVariant = {}, skus = cfg.skus || [];
    (cfg.products || []).forEach(function (p) {
      byVariant[p.single.id] = p;
      cases(p).forEach(function (c) { byVariant[c.id] = p; });
    });
    function subtotal(cart) {
      var o = document.querySelector('.orichi-subtotal');
      if (o) { var v = parseFloat(o.textContent.replace(/[^0-9.]/g, '')); if (v > 0) return Math.round(v * 100); }
      return cart.total_price;
    }
    function run() {
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var total = subtotal(cart), need = cfg.threshold - total;
          var inCart = [];
          (cart.items || []).forEach(function (it) {
            var p = byVariant[it.variant_id];
            if (p && inCart.indexOf(p) < 0 && (skus.indexOf(it.sku) > -1 || p.single.id !== it.variant_id)) inCart.push(p);
          });
          if (!inCart.length || need <= 0) { root.hidden = true; return; }
          var all = [];
          inCart.forEach(function (p) { cases(p).forEach(function (c) { if (c.available) all.push({ p: p, c: c }); }); });
          var h = '<p class="bk-fs__h">You are ' + money(need) + ' away from free shipping (orders over ' + money(cfg.threshold) + ').</p>';
          if (all.length) {
            all.sort(function (a, b) { return a.c.price - b.c.price; });
            var pick = null;
            for (var i = 0; i < all.length; i++) if (all[i].c.price >= need) { pick = all[i]; break; }
            var crosses = !!pick;
            if (!pick) pick = all[all.length - 1];
            var name = pick.p.title.length > 60 ? pick.p.title.slice(0, 57) + '…' : pick.p.title;
            h += '<p class="bk-fs__t">' + (crosses ? 'Add a case and it ships free: ' : 'Closest case: ') + '<strong>' + esc(pick.c.label) + '</strong> of ' + esc(name) +
              ', ' + money(pick.c.price) + ' (' + pp(pick.c.price, pick.c.pcs) + ' per piece)' +
              (crosses ? '.' : ', leaves ' + money(need - pick.c.price) + ' to go.') + '</p>' +
              '<a class="bk-add" href="' + cfg.addUrl + '?id=' + pick.c.id + '&amp;quantity=1" data-bk-case-add data-bk-src="fs-nudge" data-bk-sku="' + esc(pick.c.sku || '') + '" data-bk-pcs="' + pick.c.pcs + '" data-bk-value="' + (pick.c.price / 100).toFixed(2) + '">Add ' + esc(pick.c.label.toLowerCase()) + '</a>';
          } else {
            h += '<p class="bk-fs__t">Need 500+ pieces of ' + (inCart.length === 1 ? 'this part' : 'these parts') + '? Case packs are priced on request.</p>' +
              '<a class="bk-link" href="' + cfg.bulkUrl + '#quote" data-bulk-src="fs-nudge">Get case price</a>';
          }
          if (out.__h !== h && out.innerHTML.replace(/\s+/g, ' ').trim() !== h) out.innerHTML = h;
          out.__h = h;
          root.hidden = false;
        }).catch(function () {});
    }
    var t;
    function later() { clearTimeout(t); t = setTimeout(run, 600); }
    document.addEventListener('on:line-item:change', later);
    document.addEventListener('on:cart:add', later);
    run();
  }

  /* ---------- Quote form: GA4 quote_request (no personal data) ---------- */
  function QuoteForm(f) {
    f.addEventListener('submit', function () {
      var sku = (f.querySelector('input[name="contact[SKU]"]') || {}).value || '';
      track('quote_request', { form: f.id || 'bulk-quote', sku: sku });
    });
  }

  /* ---------- GA4: bulk page view, case box view, case adds ---------- */
  function caseParams(el, src) {
    return { sku: el.getAttribute('data-bk-sku') || '', pieces: parseInt(el.getAttribute('data-bk-pcs'), 10) || 0,
      value: parseFloat(el.getAttribute('data-bk-value')) || 0, currency: 'USD', source: el.getAttribute('data-bk-src') || src };
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('[data-bk-case-add]')) track('case_add', caseParams(f, 'form'));
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-bk-case-add]');
    if (a) track('case_add', caseParams(a, 'link'));
  }, true);
  function views() {
    var pg = document.querySelector('[data-bk-page]');
    if (pg) track('bulk_page_view', { parts: parseInt(pg.getAttribute('data-bk-parts'), 10) || 0, case_packs: document.querySelectorAll('[data-bkq-in][data-kind="case"]').length });
    var box = document.getElementById('bulk-case');
    if (box && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (!x.isIntersecting) return;
          io.disconnect();
          track('case_box_view', { sku: box.getAttribute('data-bk-sku') || '', has_cases: box.getAttribute('data-bk-has-cases') === '1' });
        });
      }, { threshold: 0.4 });
      io.observe(box);
    }
  }

  function init() {
    views();
    [].forEach.call(document.querySelectorAll('form.bq-form'), QuoteForm);
    [].forEach.call(document.querySelectorAll('[data-bk-calc]'), Calc);
    [].forEach.call(document.querySelectorAll('form[data-bkq]'), Quick);
    [].forEach.call(document.querySelectorAll('[data-bk-sticky]'), Sticky);
    [].forEach.call(document.querySelectorAll('[data-bk-fs]'), FreeShip);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
